import { filter, first, map, mergeMap, publishReplay, startWith, } from "rxjs/operators";
export function pause(notifier, initialState = "resumed") {
    return (source) => notifier.pipe(startWith(initialState), publishReplay(1, undefined, (published) => source.pipe(mergeMap((value) => published.pipe(filter((state) => state === "resumed"), first(), map(() => value))))));
}
//# sourceMappingURL=pause.js.map